module.exports = __webpack_public_path__ + "img/TGO.c85aca0f.svg";